export enum LANG_ISO_639_1 {
  'PT_BR' = 'br',
  'EN' = 'en',
  'ES' = 'es'
}
